export default __webpack_public_path__ + "static/ingress-3-a39b6df6d5fe702fc138411a0c6d9bc0.png";